"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTooltip = void 0;
const react_1 = require("react");
const useTooltip = () => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const onMouseEnter = (0, react_1.useCallback)((event) => {
        const el = event.target;
        const isOpen = el.offsetWidth < el.scrollWidth;
        setIsOpen(isOpen);
    }, []);
    return {
        isOpen,
        setIsOpen,
        onMouseEnter,
    };
};
exports.useTooltip = useTooltip;
